import { useQueryWithUserId } from '@northladder/services';

import { CUSTOMER_SERVICE_API } from '../customerServiceClient';

/**
 * This is to track the deal details mutation keys in react query cache.
 */
export const GRADE_REVIEW_REQUEST_HISTORY_QUERY =
  'grade-review-request-history-key';

/**
 * This hook fetches the deal details using appraisal code as parameter.
 */
export const useGradeReviewRequestHistoryListQuery = (id: string) => {
  const { data, isLoading, isFetching, isError, error, refetch } =
    useQueryWithUserId({
      queryKey: [GRADE_REVIEW_REQUEST_HISTORY_QUERY, id],
      enabled: !!id,
      networkMode: 'always',
      retry: true,
      queryFn: () => CUSTOMER_SERVICE_API.fetchGradeReviewHistory(id),
    });

  return {
    data,
    error,
    isLoading,
    isFetching,
    isError,
    refetch,
  };
};
